import { DELETEAgency, GetAgency, InsertAgency, UPDATEAgency } from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateAgencyAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/Agency`, data);
    dispatch({
      type: InsertAgency,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: InsertAgency,
      payload: "Error" + e,
    });
  }
};
export const UpdateAgencyAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Agency`, data);
    dispatch({
      type: UPDATEAgency,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATEAgency,
      payload: "Error" + e,
    });
  }
};
export const DeleteAgencyAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Agency?id=${id}`);
    dispatch({
      type: DELETEAgency,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETEAgency,
      payload: "Error" + e,
    });
  }
};
export const GetAllAgencyAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Agency?${quary}`);
    dispatch({
      type: GetAgency,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GetAgency,
      payload: "Error" + e,
    });
  }
};
